module.exports = __webpack_public_path__ + "img/icon47.c0bff88c.png";